<Input
  id={{this.field.id}}
  @value={{this.field.value}}
  tabindex={{this.field.tabindex}}
  class={{this.fieldClass}}
  placeholder={{this.field.translatedPlaceholder}}
  autocomplete={{this.autocomplete}}
/>